/**
 * Centralized API URL resolver.
 *
 * In production (nexusdesignai.com), if REACT_APP_BACKEND_URL is missing or
 * points to a staging host, fall back to the production API URL.
 * This prevents all API calls — login, fetch, auth — from routing to staging.
 */
const RAW_API_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

const PRODUCTION_API = 'https://api.nexusdesignai.com';

export const API_URL = (() => {
  if (typeof window === 'undefined') return RAW_API_URL;
  const isProduction = window.location.hostname === 'nexusdesignai.com' ||
                       window.location.hostname === 'www.nexusdesignai.com';
  if (isProduction && (!RAW_API_URL || RAW_API_URL.includes('staging'))) {
    if (RAW_API_URL.includes('staging')) {
      console.warn(
        '[Nexus] REACT_APP_BACKEND_URL points to staging in production. ' +
        `Falling back to ${PRODUCTION_API}. Please update the environment variable on Render.`
      );
    }
    return PRODUCTION_API;
  }
  return RAW_API_URL;
})();
